export default __webpack_public_path__ + "static/media/obstacle.3e8898a0.png";